<template>
  <div>
    <Card back toolsColumns>
      <template v-slot:header>
        <h4 class="d-inline">مدیریت مشتریانـ</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="contain-fluid">
          <div class="row" v-if="!more">
            <div class="col-12 text-center">
              <a @click="more = true">فیــلترهای بیشتر <i class="fad fa-glassess"></i></a>
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-md-3 col-12">
              <small :id="'Lbl' + 'State'"> استــان </small>
              <SearchableCombo :edit="false" :grp="10" :code="null" @ResultCombo="GetResultState" :rownumintable="3" :defaultvalue="tblCombogrp10state" :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="'State'" :keyItem="'State'" :disabled="false"> </SearchableCombo>
            </div>
            <div class="col-md-3 col-12">
              <small :id="'Lbl' + 'City'"> شـهر </small>
              <SearchableCombo
                v-if="rendergrid"
                :edit="false"
                :grp="11"
                :code="tblCombogrp10state"
                @ResultCombo="GetResultCity"
                :rownumintable="3"
                :defaultvalue="tblCombogrp11Shahr"
                :action="'TblCrmCombo/GetComboByParentId'"
                :method="'POST'"
                :idinput="'City'"
                :keyItem="'City'"
                :disabled="tblCombogrp10state == null"
              >
              </SearchableCombo>
            </div>
            <div class="col-12 text-center">
              <a @click="more = false">فیــلترهای بیشتر <i class="fad fa-glassess"></i></a>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-md-3 col-12">
              <small>کد مشتری</small>
              <input @submit="Search()" @keydown="Enter($event)" type="number" class="form-control" v-model="CustCode" id="txtCustCode" />
            </div>
            <div class="col-md-3 col-12">
              <small>کد بازاریابی</small>
              <input type="number" @keydown="Enter($event)" class="form-control" v-model="BazaryabiCode" />
            </div>
            <div class="col-md-3 col-12">
              <small>تمامی فیلدها</small>
              <input type="text" @keydown="Enter($event)" class="form-control" v-model="Allfields" />
            </div>
            <div class="col-md-3 col-12">
              <button @click="Search" class="btn btn-success mt-4 w-100">جستــجو</button>
            </div>
          </div>
          <div class="row my-5 px-3">
            <BnpGrid Selectable :Sortable="true" :action="true" :propsRows="propsRows" :propsColumn="propsColumn" :NoRowNum="true" v-if="$store.state.renderComponentGrid">
              <template slot="action-slot" slot-scope="props">
                <a href="javascript:;" class="mr-2 badge" data-title="مشاهده جزئیات" @click="$FindeCustomerById('DetailCustomer', props.props.id, false, $event)" @click.middle="$FindeCustomerById('DetailCustomer', props.props.id, false, $event)"
                  ><h6><span class="fas fa-eye font-weight-bold hover-danger"></span></h6
                ></a>
                <a href="javascript:;" class="mr-2 badge" data-title="نامه ها و فایلها" @click="$FindeCustomerById('DetailCustomer', props.props.id, 6, $event)" @click.middle="$FindeCustomerById('DetailCustomer', props.props.id, 6, $event)"
                  ><h6><span class="fad fa-mail-bulk hover-warning"></span></h6
                ></a>
                <a href="javascript:;" class="mr-2 badge" data-title="دمو و حضور" @click="$FindeCustomerById('DetailCustomer', props.props.id, 7, $event)" @click.middle="$FindeCustomerById('DetailCustomer', props.props.id, 7, $event)"
                  ><h6><span class="fad fa-business-time hover-info"></span></h6
                ></a>
                <a href="javascript:;" class="mr-2 badge" data-title="هشدارها" @click="$FindeCustomerById('DetailCustomer', props.props.id, 1, $event)" @click.middle="$FindeCustomerById('DetailCustomer', props.props.id, 1, $event)"
                  ><h6><span class="fas fa-bell t hover-danger"></span></h6
                ></a>
              </template>
              <template slot="customerName" slot-scope="props">
                <span> {{ props.props.customerName }}</span> <span v-if="props.props.baygani">(بایگانی شده)</span>
              </template>
            </BnpGrid>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
export default {
  components: { Card, BnpGrid, SearchableCombo },
  data() {
    return {
      more: false,
      propsColumn: [
        { name: 'customerCode', label: 'کد', visibility: true },
        { name: 'customerName', label: 'نام مشتری', visibility: true },
        { name: 'codeBazaryabi', label: ' کد بازاریابی', visibility: true },
        { name: 'tblCombogrp37AxarinVazeitName', label: 'وضعیت فعالیت', visibility: true },
      ],
      propsRows: [],
      Allfields: '',
      CustCode: null,
      BazaryabiCode: null,
      tblCombogrp11Shahr: null,
      tblCombogrp10state: null,
      rendergrid: true,
    }
  },
  methods: {
    OnViewCustomer(row) {
      this.$router.push({ name: 'Detail' + this.$route.name, params: { Status: 'Edit', DataRow: row } })
      this.$store.state.renderComponent = false
      this.$nextTick(() => {
        this.$store.state.renderComponent = true
      })
    },
    Search() {
      this.$store.state.loading = true
      var DataAxiosSearch = {
        Action: 'TblCustomerCrm/SearchCustomer',
        Method: 'POST',
        ArryfildValue: {
          CustCode: this.CustCode,
          Allfields: this.Allfields,
          BazaryabiCode: this.BazaryabiCode,
          tblCombogrp11Shahr: this.tblCombogrp11Shahr,
          tblCombogrp10state: this.tblCombogrp10state,
        },
      }

      this.$PostData(DataAxiosSearch)
        .then((result) => {
          this.propsRows = result
          this.propsRows.sort((a, b) => {
            if (a.customerCode > b.customerCode) {
              return -1
            }
            if (a.customerCode < b.customerCode) {
              return 1
            }
            return 0
          })
          this.$store.state.CustomerManagerSearchResult = result
          this.$store.state.CustomerManagerCustCode = this.CustCode
          this.$store.state.CustomerManagerAllfields = this.Allfields
          this.$store.state.CustomerManagerBazaryabiCode = this.BazaryabiCode
          this.$store.state.CustomerManagertblCombogrp11Shahr = this.tblCombogrp11Shahr
          this.$store.state.CustomerManagertblCombogrp10state = this.tblCombogrp10state
          this.$mySweetDefaultTost('جستـــجو موفـق', '', 'success', 1000)
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
        .finally(() => {
          this.$store.state.loading = false
        })
    },
    GetResultState(data) {
      this.tblCombogrp10state = data.id
      this.rendergrid = false
      this.$nextTick(() => {
        this.rendergrid = true
      })
    },
    GetResultCity(data) {
      this.tblCombogrp11Shahr = data.id
    },
    // OnDetail(data) {
    //   if (this.$store.state.Customer.Customer) {
    //     this.$store.state.Customer.Customer.Id = data.id
    //   }
    //   this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: data.id } })
    // },
    // OnAndicator(data) {
    //   this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: data.id, activeTab: 6 } })
    // },
    // OnDemo(data) {
    //   this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: data.id, activeTab: 7 } })
    // },
    // OnTask(data) {
    //   this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: data.id, activeTab: 1 } })
    // },
    Enter(e) {
      if (e.which === 13) {
        this.Search()
      }
    },
  },
  created() {
    setTimeout(() => {
      this.$store.state.renderComponentGrid = false
      this.$nextTick(() => {
        this.$store.state.renderComponentGrid = true
      })

      console.log('Delayed for 1 second.')
    }, '4000')
    if (this.$store.state.CustomerManagerSearchResult && this.$store.state.CustomerManagerSearchResult != null && this.$store.state.CustomerManagerSearchResult != '') {
      this.propsRows = this.$store.state.CustomerManagerSearchResult
      this.CustCode = this.$store.state.CustomerManagerCustCode
      this.Allfields = this.$store.state.CustomerManagerAllfields
      this.BazaryabiCode = this.$store.state.CustomerManagerBazaryabiCode
      this.tblCombogrp11Shahr = this.$store.state.CustomerManagertblCombogrp11Shahr
      this.tblCombogrp10state = this.$store.state.CustomerManagertblCombogrp10state
    }
    // this.Search()
  },
  mounted() {
    document.getElementById('txtCustCode').focus()
  },
  beforeDestroy() {
    this.CustCode = null
    this.$store.state.CustomerManagerCustCode = null
  },
}
</script>
